import { Inject, Injectable } from "@angular/core";
import { NavigationExtras } from "@angular/router";
import { createEffect } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { CORE_ROUTE, CoreState } from "@obg/ngx.core";
import { RouteAction, RouteSelector } from "@obg/ngx.router";
import { DataBusFacade, EventBusFacade } from "remote-module-context";
import { map, tap } from "rxjs/operators";

import { T_SHELL_DATA_BUS_FACADE, T_SHELL_EVENT_BUS_FACADE } from "../injection";
import { observeEvent } from "../util/observe-event";

@Injectable({
	providedIn: "root",
})
export class NavigationEffects {
	navigateTo404$ = createEffect(() =>
		observeEvent<void>(this.eventBus, "navigateTo404").pipe(map(() => RouteAction.navigate(CORE_ROUTE.notFound)))
	);

	navigateByUrl$ = createEffect(() =>
		observeEvent<{ url: string; extras?: NavigationExtras }>(this.eventBus, "navigateByUrl").pipe(
			map(({ url, extras }) => RouteAction.navigateByUrl(url, extras))
		)
	);

	currentPath$ = createEffect(
		() =>
			this.store
				.select(RouteSelector.getCurrent)
				.pipe(
					tap((currentRoute) =>
						this.dataBus.dispatch({ key: "currentPath", value: currentRoute?.externalUrl })
					)
				),
		{ dispatch: false }
	);

	navigateToDeposit$ = createEffect(() =>
		observeEvent<{ queryParams: Record<string, string> }>(this.eventBus, "navigateToDeposit").pipe(
			map(({ queryParams }) => RouteAction.navigate(CORE_ROUTE.payment.deposit, undefined, { queryParams }))
		)
	);

	constructor(
		@Inject(T_SHELL_DATA_BUS_FACADE) private dataBus: DataBusFacade,
		@Inject(T_SHELL_EVENT_BUS_FACADE) private eventBus: EventBusFacade,
		private store: Store<CoreState>
	) {}
}
